<script setup>
import { computed, toRef } from 'vue';
import { useChannelIcon } from './provider';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

// Os dois canais próprios da Winker são STI sobre canal nativo — Channel::Winker sobre
// Channel::Api e Channel::WinkerAssistant sobre Channel::WebWidget —, então
// `channel_type` guarda a classe BASE e `useChannelIcon` devolveria o ícone genérico do
// pai (a rosca de API no primeiro caso, o globo de site no segundo). O backend os
// distingue por booleano (`is_winker` / `is_winker_assistant` no _inbox.json.jbuilder),
// e cada um desenha aqui a MESMA arte que a inbox usa como avatar, como MÁSCARA CSS: o
// canal alfa do PNG dá a forma e `currentColor` (via `bg-current`) pinta — o ícone fica
// preto-e-branco e SENSÍVEL A TEMA, porque a cor vem do token de texto e não do arquivo.
// Uma `<img>` desenharia o PNG bicolor da Winker IA e não obedeceria ao tema.
// O tamanho é herdado das classes de quem chama (size-3 na barra lateral, size-5 na
// listagem, w-full/h-full no distintivo do Avatar).
// A url da máscara vive no :style porque o nome do arquivo tem separadores que o parser
// de valor arbitrário do Tailwind transformaria em espaço.
const WINKER_MASK_ASSETS = {
  winker: '/brand-assets/logo_thumbnail_2.png',
  winkerAssistant: '/brand-assets/logo-winker-ia.png',
};

const maskStyle = asset => ({
  maskImage: `url('${asset}')`,
  WebkitMaskImage: `url('${asset}')`,
  maskSize: 'contain',
  WebkitMaskSize: 'contain',
  maskRepeat: 'no-repeat',
  WebkitMaskRepeat: 'no-repeat',
  maskPosition: 'center',
  WebkitMaskPosition: 'center',
});

const winkerMaskStyle = computed(() => {
  if (props.inbox?.is_winker) return maskStyle(WINKER_MASK_ASSETS.winker);
  if (props.inbox?.is_winker_assistant)
    return maskStyle(WINKER_MASK_ASSETS.winkerAssistant);

  return null;
});

const channelIcon = useChannelIcon(toRef(props, 'inbox'));
</script>

<template>
  <span
    v-if="winkerMaskStyle"
    class="inline-block bg-current text-n-slate-11"
    :style="winkerMaskStyle"
  />
  <Icon v-else :icon="channelIcon" />
</template>
